// Simple admin authentication service
// Uses localStorage for session persistence

const ADMIN_PASSWORDS = (process.env.REACT_APP_ADMIN_PASSWORD || 'admin123')
  .split(',')
  .map(pwd => pwd.trim());
const AUTH_KEY = 'indie_chess_admin_auth';

// Check if user is admin
export const isAdmin = () => {
  try {
    const authData = localStorage.getItem(AUTH_KEY);
    if (!authData) return false;
    
    const { isAuthenticated, timestamp } = JSON.parse(authData);
    
    // Check if auth is expired (24 hours)
    const now = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000;
    
    if (now - timestamp > twentyFourHours) {
      adminLogout();
      return false;
    }
    
    return isAuthenticated === true;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

// Admin login with password
export const adminLogin = (password) => {
  try {
    if (ADMIN_PASSWORDS.includes(password)) {
      const authData = {
        isAuthenticated: true,
        timestamp: Date.now()
      };

      localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
      return { success: true };
    } else {
      return { success: false, error: 'Invalid password' };
    }
  } catch (error) {
    console.error('Error during admin login:', error);
    return { success: false, error: 'Login failed' };
  }
};

// Admin logout
export const adminLogout = () => {
  try {
    localStorage.removeItem(AUTH_KEY);
    return true;
  } catch (error) {
    console.error('Error during admin logout:', error);
    return false;
  }
};

// Get admin session info
export const getAdminSession = () => {
  try {
    const authData = localStorage.getItem(AUTH_KEY);
    if (!authData) return null;
    
    const { timestamp } = JSON.parse(authData);
    return {
      loginTime: new Date(timestamp),
      isValid: isAdmin()
    };
  } catch (error) {
    console.error('Error getting admin session:', error);
    return null;
  }
};

// Extend admin session
export const extendAdminSession = () => {
  try {
    if (isAdmin()) {
      const authData = {
        isAuthenticated: true,
        timestamp: Date.now()
      };
      localStorage.setItem(AUTH_KEY, JSON.stringify(authData));
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error extending admin session:', error);
    return false;
  }
};